import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Heart, Brain, PawPrint, Clock, Wind } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    num: 1,
    title: 'Yoga para dormir mejor',
    desc: 'Rutinas relajantes para un descanso profundo.',
    price: 'ARS $5.990',
    icon: <Moon size={24} data-id="element-296" />,
    color: 'from-pastel-lavender to-pastel-lavender-dark',
    badgeColor: 'bg-pastel-lavender-dark text-white'
  }, {
    num: 2,
    title: 'Yoga anti ansiedad infantil',
    desc: 'Herramientas para calmar desbordes emocionales.',
    price: 'ARS $5.990',
    icon: <Heart size={24} data-id="element-297" />,
    color: 'from-pastel-pink to-rose-300',
    badgeColor: 'bg-rose-400 text-white'
  }, {
    num: 3,
    title: 'Yoga y concentración',
    desc: 'Ideal para mejorar el enfoque en la escuela.',
    price: 'ARS $5.990',
    icon: <Brain size={24} data-id="element-298" />,
    color: 'from-pastel-aqua to-teal-300',
    badgeColor: 'bg-teal-500 text-white'
  }, {
    num: 4,
    title: 'Yoga divertido con animales',
    desc: 'Posturas lúdicas para aprender jugando.',
    price: 'ARS $5.990',
    icon: <PawPrint size={24} data-id="element-299" />,
    color: 'from-pastel-yellow to-amber-300',
    badgeColor: 'bg-amber-500 text-white'
  }, {
    num: 5,
    title: 'Rutinas rápidas de 5 min',
    desc: 'Para esos días donde no hay mucho tiempo.',
    price: 'ARS $5.990',
    icon: <Clock size={24} data-id="element-300" />,
    color: 'from-pastel-mint to-emerald-300',
    badgeColor: 'bg-emerald-500 text-white'
  }, {
    num: 6,
    title: 'Mindfulness y respiración',
    desc: 'Técnicas simples para volver al centro.',
    price: 'ARS $5.990',
    icon: <Wind size={24} data-id="element-301" />,
    color: 'from-indigo-200 to-pastel-lavender-dark',
    badgeColor: 'bg-indigo-400 text-white'
  }];
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-302">
      {/* Decorative background blob */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-pastel-lavender/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-303"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-pastel-mint/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-304"></div>

      <div className="container mx-auto px-5 sm:px-8 lg:px-12 relative z-10" data-id="element-305">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-306">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-gray-900 mb-6" data-id="element-307">
            ¿Qué incluye el{' '}
            <span className="text-gradient from-pastel-lavender-dark to-pastel-pink" data-id="element-308">
              Kit Completo?
            </span>
          </h2>
          <p className="text-lg text-gray-600 mb-6" data-id="element-309">
            6 tomos digitales diseñados pedagógicamente para que tus hijos
            aprendan a gestionar sus emociones mientras se divierten.
          </p>

          <div className="inline-flex flex-col sm:flex-row items-center gap-2 sm:gap-4 bg-pastel-lavender/15 border border-pastel-lavender/40 px-6 py-3 rounded-2xl" data-id="element-310">
            <p className="text-base text-gray-600" data-id="element-311">
              Valor total:{' '}
              <span className="line-through font-bold" data-id="element-312">ARS $34.990</span>
            </p>
            <span className="hidden sm:inline text-gray-400" data-id="element-313">·</span>
            <p className="text-base sm:text-lg font-display font-bold text-pastel-lavender-dark" data-id="element-314">
              Hoy te lo llevás por ARS $19.990
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-315">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="glass-card rounded-3xl p-6 flex flex-col items-center text-center group hover:shadow-xl transition-all duration-300" data-id="element-316">
              {/* CSS Mini Book Mockup */}
              <div className="relative w-32 h-44 mb-8 transform group-hover:-translate-y-2 group-hover:rotate-2 transition-all duration-300" data-id="element-317">
                <div className="absolute inset-0 bg-black/10 rounded-r-lg blur-md translate-x-2 translate-y-2" data-id="element-318"></div>
                <div className="absolute left-0 top-0 bottom-0 w-3 bg-white/40 rounded-l-lg z-20 border-r border-white/20" data-id="element-319"></div>
                <div className={`absolute inset-0 bg-gradient-to-br ${tomo.color} rounded-r-lg rounded-l-sm shadow-inner flex flex-col items-center justify-center p-4 text-white z-10`} data-id="element-320">
                  <div className="mb-2 opacity-90" data-id="element-321">{tomo.icon}</div>
                  <div className="font-display font-bold text-2xl opacity-50" data-id="element-322">
                    0{tomo.num}
                  </div>
                </div>
              </div>

              <div className={`px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4 ${tomo.badgeColor}`} data-id="element-323">
                Tomo {tomo.num}
              </div>
              <h3 className="text-xl font-display font-bold text-gray-800 mb-2" data-id="element-324">
                {tomo.title}
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-325">{tomo.desc}</p>
              <div className="mt-auto pt-3 border-t border-gray-100 w-full" data-id="element-326">
                <span className="text-sm text-gray-500" data-id="element-327">
                  Valor individual:{' '}
                </span>
                <span className="text-sm font-display font-bold text-gray-800" data-id="element-328">
                  {tomo.price}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}